import * as React from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckIcon from '@mui/icons-material/Check'
import { IconContext } from 'react-icons'

const SelectContract = ({ mode, setContractSelected }) => {
  const [selected, setSelected] = React.useState(0)

  const plans = [
    {
      id: 1,
      name: 'Gratuit',
      price: 0,
      modules: [
        { name: 'Utilisateurs : 1', active: 1 },
        { name: 'Clients', active: 1 },
        { name: 'Devis : 5 par mois', active: 1 },
        { name: 'Interventions : 5 par mois', active: 1 },
        { name: 'Factures : 5 par mois', active: 1 },
        { name: 'Emails', active: 1 },
        { name: 'Calendrier', active: 0 },
        { name: 'Fournisseurs', active: 0 },
        { name: 'Comptabilité', active: 0 }
      ]
    },
    {
      id: 2,
      name: 'Basique',
      price: 5,
      modules: [
        { name: 'Utilisateurs : Illimités', active: 1 },
        { name: 'Clients', active: 1 },
        { name: 'Devis : 10 par mois', active: 1 },
        { name: 'Interventions : 10 par mois', active: 1 },
        { name: 'Factures : 10 par mois', active: 1 },
        { name: 'Emails', active: 1 },
        { name: 'Calendrier', active: 1 },
        { name: 'Fournisseurs', active: 0 },
        { name: 'Comptabilité', active: 0 }
      ],
      link: 'https://buy.stripe.com/eVa7vmahe5WbgIo6oo'
    },
    {
      id: 3,
      name: 'Pro',
      price: 10,
      modules: [
        { name: 'Utilisateurs : Illimités', active: 1 },
        { name: 'Clients', active: 1 },
        { name: 'Devis : Illimités', active: 1 },
        { name: 'Interventions : Illimitées', active: 1 },
        { name: 'Factures : Illimitées', active: 1 },
        { name: 'Emails', active: 1 },
        { name: 'Calendrier', active: 1 },
        { name: 'Fournisseurs', active: 1 },
        { name: 'Comptabilité', active: 1 }
      ]
    }
  ]

  React.useEffect(() => {
    setContractSelected(selected)
  }, [selected, setContractSelected])

  return (
    <Box sx={{ margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
        {plans
          .filter((plan) => mode === 'wizard' || plan.id !== 1)
          .map((plan) => (
            <PricingCard key={plan.id} properties={plan} setSelected={setSelected} selected={selected} />
          ))}
      </Box>
    </Box>
  )
}

const PricingCard = ({ properties, setSelected, selected }) => {
  const selectContract = (contractId) => {
    if (contractId === 0) {
      setSelected(0)
    } else {
      setSelected((prev) => (prev === contractId ? 0 : contractId))
    }
  }

  return (
    <Card
      sx={{
        width: 260,
        border: selected === properties.id ? '2px solid #1976d2' : '1px solid #ddd',
        boxShadow: selected === properties.id ? 6 : 1,
        transition: 'all 0.3s ease',
        borderRadius: 2
      }}
    >
      <CardContent>
        <Typography variant='h6' align='center' color='primary.main' gutterBottom>
          {properties.name}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', mb: 2 }}>
          <Typography variant='h5'>{properties.price}€</Typography>
          <Typography variant='body2' color='text.secondary' sx={{ ml: 0.5 }}>
            / Mois
          </Typography>
        </Box>

        {properties.modules.map((module, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <IconContext.Provider value={{ size: '20px' }}>
              {module.active ? <CheckIcon sx={{ color: 'green' }} /> : <CancelIcon sx={{ color: 'lightgray' }} />}
            </IconContext.Provider>
            <Typography variant='body2'>{module.name}</Typography>
          </Box>
        ))}
      </CardContent>

      <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          variant={selected === properties.id ? 'outlined' : 'contained'}
          color='primary'
          onClick={() => (selected === properties.id ? selectContract(0) : selectContract(properties.id))}
          aria-label={`Sélectionner ${properties.name}`}
        >
          {selected === properties.id ? 'Désélectionner' : 'Sélectionner'}
        </Button>
      </CardActions>
    </Card>
  )
}

export default SelectContract
